import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportMemberVoucherPageRoutingModule } from './report-member-voucher-routing.module';

import { ReportMemberVoucherPage } from './report-member-voucher.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportMemberVoucherPageRoutingModule
  ],
  declarations: [ReportMemberVoucherPage]
})
export class ReportMemberVoucherPageModule {}
